module.exports = __webpack_public_path__ + "img/255.1aadbd20.png";